import moment from "moment/moment";
import {route} from "../../../../functions/route";

const getDefaultState = () => {
	return {
		startingCall: false,
		activeCall: null,
		startTimestamp: null,
		callDuration: null,
	};
};

const state = getDefaultState();

const actions = {
	reset({commit}) {
		commit("RESET");
	},
	startCall({dispatch, state}, client) {
		state.startingCall = true;
		return new Promise((resolve, reject) => {
			http().post(route("clients/:client/start-call", [client])).then(response => {
				dispatch("setActiveCall", response.data.data);
				resolve(response.data.data);
			}).finally(() => {
				state.startingCall = false;
			});
		});
	},
	setActiveCall({commit, state}, data = null) {
		state.activeCall = data;

		if (!state.activeCall) {
			return commit("RESET");
		}

		let start = moment(state.activeCall.created_at);
		let end = moment();
		let diff = end.diff(start);
		state.startTimestamp = moment.utc(diff);
		state.callDuration = state.startTimestamp.format("HH:mm:ss");
		state.callTimer = setInterval(function () {
			state.startTimestamp.add(1, "second");
			state.callDuration = state.startTimestamp.format("HH:mm:ss");
		}, 1000);
	},
};

const mutations = {
	RESET(state) {
		clearInterval(state.callTimer);
		Object.assign(state, getDefaultState());
	},
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
};
